/* eslint-disable no-lone-blocks */
import axios from 'axios'
import {createSlice, createAsyncThunk} from '@reduxjs/toolkit'
import {toast} from 'react-toastify'
import {GetAllData as tagslist} from '../../Tags/TagSlice/TagsSlices'
import {stopLoading, startLoadding} from '../../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {
  totalRecipients,
  totalUnsubscribedContactCount,
} from '../../../new-message/BulkMessageSlice/BulkMessageSlice'
import {ENV} from '../../../../../Utils/_helpers/EnvHelper'
import {fetchDataApiV3} from '../../../../../../services/cellcast.v3'

const API_URL = ENV().REACT_APP_API_URL
const initialState: any = {
  subscriberList: [],
  FieldName: [],
  FieldNameLoading: false,
  Report: [],
  uploadataCount: [],
  contectData: {},
}

const RouteUrl = {
  GetLastReport: 'uploadHistory/getLastUploadReport',
  GetAllData: 'mobile/group/data/',
  GetData: 'mobile/group',
  EditData: 'group/updatequickcontact',
  CreateContactData: 'group/quickcontact',
  DeleteData: 'group/deletemulticontact',
  CreateData: 'group',
  CreateDataPost: 'mobile/group/',
  updateBYCopy: 'group/uploadCustomContact',
}
const thunkName = {
  GetLastReport: 'uploadHistory/getLastUploadReport',
  GetAllData: 'group-GetALLDATA',
  GetData: 'group-GetGroupdata',
  EditData: 'group-updatequickcontact',
  CreateContactData: 'group-addquickcontact',
  DeleteData: 'group-Delete',
  CreateData: 'group-Create',
  CreateDataPost: 'group-Createpost',
  updateBYCopy: 'group-uploadCustomContact',
}

export const GetContectData: any = createAsyncThunk(
  'GetContectData',
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}contact/contactInfo`, {
      params: data.payload,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const GetLastReport: any = createAsyncThunk(
  thunkName.GetLastReport,
  async (data: any, thunkApi) => {
    const response = await axios.get(`${API_URL}${RouteUrl.GetLastReport}`, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)
export const GetAllData: any = createAsyncThunk(
  thunkName.GetAllData,
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.get(`${API_URL}${RouteUrl.GetAllData}${data?.id}`, {
      params: data.page,
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    thunkApi.dispatch(stopLoading())
    return response.data
  }
)

export const GetData: any = createAsyncThunk(thunkName.GetData, async (data, thunkApi) => {
  const response = await axios.get(`${API_URL}${RouteUrl.GetData}`, {
    params: data,
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  thunkApi.dispatch(stopLoading())

  return response.data
})

export const DeleteData: any = createAsyncThunk(
  thunkName.DeleteData,
  async (data: any, thunkApi) => {
    const response = await axios.post(`${API_URL}${RouteUrl.DeleteData}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(GetAllData({id: data?.group}))
  }
)
export const CreateData: any = createAsyncThunk(
  thunkName.CreateData,
  async (data: any, thunkApi) => {
    thunkApi.dispatch(startLoadding())

    const response = await axios.post(`${API_URL}${RouteUrl.CreateData}`, data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }
    thunkApi.dispatch(stopLoading())
    thunkApi.dispatch(tagslist())
    thunkApi.dispatch(GetData())

    setTimeout(() => {
      thunkApi.dispatch(GetAllData({id: response?.data?.data?.group?._id}))
    }, 8000)
  }
)
export const CreateDataPost: any = createAsyncThunk(
  thunkName.CreateDataPost,
  async (data: any, thunkApi: any) => {
    thunkApi.dispatch(startLoadding())
    let {subscriberData} = thunkApi.getState()

    const response = await axios.put(
      `${API_URL}${RouteUrl.CreateDataPost}${subscriberData?.FieldName?.data?._id}`,
      data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )

    setTimeout(() => {
      thunkApi.dispatch(GetAllData({id: subscriberData?.FieldName?.data?._id}))
    }, 8000)

    thunkApi.dispatch(GetData())
    thunkApi.dispatch(tagslist())
  }
)

export const UpdateByCopyPast: any = createAsyncThunk(
  thunkName.updateBYCopy,
  async (data: any, thunkApi: any) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.post(`${API_URL}${RouteUrl.updateBYCopy}`, data?.data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })

    {
      response.data?.status == true && toast.success(response.data.message)
    }

    thunkApi.dispatch(GetData()).then((response: any) => {
      if (response?.payload?.data?.id)
        thunkApi.dispatch(GetAllData({id: response?.payload?.data?.id}))
    })
    thunkApi.dispatch(tagslist())
  }
)
export const optoutContact: any = createAsyncThunk(
  'optoutContact',
  async (data: any, thunkApi: any) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.put(`${API_URL}group/contact/optout`, data?.data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }

    thunkApi.dispatch(GetData())
    thunkApi.dispatch(GetAllData({id: data?.id}))
    thunkApi.dispatch(tagslist())
  }
)
export const optInContact: any = createAsyncThunk(
  'optInContact',
  async (data: any, thunkApi: any) => {
    thunkApi.dispatch(startLoadding())
    const response = await axios.put(`${API_URL}group/contact/subscribe`, data?.data, {
      headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
    })
    {
      response.data?.status == true && toast.success(response.data.message)
    }

    thunkApi.dispatch(GetData())
    thunkApi.dispatch(GetAllData({id: data?.id}))
    thunkApi.dispatch(tagslist())
  }
)

export const UpdateData: any = createAsyncThunk(thunkName.EditData, async (data: any, thunkApi) => {
  thunkApi.dispatch(startLoadding())

  let response: any
  if (data?.region) {
    response = fetchDataApiV3(
      'contact',
      {
        data: {...data?.data, id: data?.id, tag_ids: data?.tag_ids || []},
        action: 'update_contact',
      },
      data?.region
    )
  } else {
    response = await axios.put(
      `${API_URL}${RouteUrl.EditData}/${data?.groupId}/${data?.id}`,
      data.data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
  }

  if (response.data?.status == true) {
    toast.success(response.data.message)
  }

  thunkApi.dispatch(stopLoading())
  thunkApi.dispatch(GetData())
  thunkApi.dispatch(GetAllData({id: data?.groupId}))
  thunkApi.dispatch(
    totalRecipients({
      to: {
        selectedType: 'all',
        value: 'all',
      },
    })
  )
  thunkApi.dispatch(totalUnsubscribedContactCount(data?.groupId))

  if (data.callbackFn) {
    data.callbackFn()
  }
})

export const CreateContactData: any = createAsyncThunk(thunkName.CreateContactData, async (data: any, thunkApi) => {
  thunkApi.dispatch(startLoadding())

  let response: any
  if (data?.region) {
    response = fetchDataApiV3(
      'contact',
      {
        data: {...data?.data, id: data?.id, tag_ids: data?.tag_ids || []},
        action: 'update_contact',
      },
      data?.region
    )
  } else {
    response = await axios.put(
      `${API_URL}${RouteUrl.CreateContactData}/${data?.groupId}`,
      data.data,
      {
        headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
      }
    )
  }

  if (response.data?.status == true) {
    toast.success(response.data.message)
  }

  thunkApi.dispatch(stopLoading())
  thunkApi.dispatch(GetData())
  thunkApi.dispatch(GetAllData({id: data?.groupId}))
  thunkApi.dispatch(
    totalRecipients({
      to: {
        selectedType: 'all',
        value: 'all',
      },
    })
  )
  thunkApi.dispatch(totalUnsubscribedContactCount(data?.groupId))

  if (data.callbackFn) {
    data.callbackFn()
  }
})

export const UploadSuccessData: any = createAsyncThunk('UploadSuccessData', async () => {
  const response = await axios.get(`${API_URL}uploadHistory/getLastUploadReport`, {
    headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
  })
  return response.data
})
const Subscriber = createSlice({
  name: 'Subscriber',
  initialState,

  reducers: {
    removeCount: (state) => {
      return {...state, uploadataCount: undefined, Report: undefined}
    },
    removeData: (state, {payload}) => {
      axios.post(
        `${API_URL}uploadHistory/setMarkAsRead`,
        {},
        {
          headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
        }
      )
      return {...state, uploadataCount: payload, Report: undefined}
    },
    LoopWithDelay: (state: any) => {
      var i = 1

      const myLoop = () => {
        setTimeout(async () => {
          const response = await axios.get(`${API_URL}${RouteUrl.GetLastReport}`, {
            headers: {Authorization: `Bearer ${localStorage.getItem('token')}`},
          })

          i++
          if (i < 5 && response?.data?.data == null) {
            myLoop()
          } else {
            return {...state, Report: 'dnfsdjndjsfj'}
          }
        }, 3000)
      }
      myLoop()
    },
    StoreReportData: (state, {payload}) => {
      return {...state, Report: payload}
    },
  },

  extraReducers: (builder) => {
    builder.addCase(GetContectData.fulfilled, (state, action) => {
      return {...state, contectData: action?.payload}
    })
    builder.addCase(GetAllData.fulfilled, (state, action) => {
      return {...state, subscriberList: action?.payload}
    })
    builder.addCase(GetData.pending, (state) => {
      return {...state, FieldNameLoading: true}
    })
    builder.addCase(GetData.fulfilled, (state, {payload}) => {
      return {...state, FieldName: payload, FieldNameLoading: false}
    })
    builder.addCase(GetData.rejected, (state) => {
      return {...state, FieldNameLoading: false}
    })
    builder.addCase(GetLastReport.fulfilled, (state, action) => {
      return {...state, Report: action?.payload?.data == null ? undefined : action?.payload}
    })
    builder.addCase(UploadSuccessData.fulfilled, (state, action) => {
      return {...state, Report: action?.payload?.data == null ? undefined : action?.payload}
    })
  },
})
export const {removeData, LoopWithDelay, StoreReportData, removeCount} = Subscriber.actions

export default Subscriber.reducer
